FormDialogService = ->
  _open :(options , callback) ->
    dialog = document.createElement('input')
    dialog.type = 'file'
    dialog.style  = 'display:none'
    options = options || {}
    document.body.appendChild(dialog)

    if options.accept
      dialog.accept = options.accept

    dialog.addEventListener('change', ->
      if !callback
        return
      callback(dialog.files[0],dialog.value)
      document.body.removeChild(dialog)
    )
    setTimeout(() ->
      dialog.click()
    , 0)

module.exports = FormDialogService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/form-file-dialog-service.coffee